import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
const Playlist: React.FC<IconProps> = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 93 92" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d_6060_10885)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.68 60.607c0 3.19-5.26 3.19-5.26 0v-5.153h-4.824c-3.461 0-3.461-4.807 0-4.807l4.825-.04v-5.214c0-3.19 5.258-3.19 5.258 0v5.214l4.775.04c3.395 0 3.395 4.807 0 4.807H74.68v5.153z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter1_d_6060_10885)" fill="#fff">
        <path d="M14.138 24.47h63.73c5.678 0 5.678 8.62 0 8.62h-63.73c-5.68 0-5.68-8.62 0-8.62zM14.138 58.913H53.06c5.678 0 5.678 8.618 0 8.618H14.138c-5.68 0-5.68-8.619 0-8.619zM14.138 41.69H53.06c5.678 0 5.678 8.62 0 8.62H14.138c-5.68 0-5.68-8.62 0-8.62z" />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d_6060_10885"
          x={58}
          y={43}
          width={28}
          height={28}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6060_10885"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6060_10885"
            result="shape"
          />
        </filter>
        <filter
          id="prefix__filter1_d_6060_10885"
          x={5.879}
          y={24.471}
          width={80.248}
          height={51.06}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6060_10885"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6060_10885"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

const MemoPlaylist = React.memo(Playlist);
export default MemoPlaylist;
